export const getErrorMessage = ({ errorCopy, isSucursal }) => {
  if (typeof errorCopy?.message === 'function') {
    return errorCopy.message({ isSucursal });
  }

  return errorCopy?.message;
};

const REVIEW_BOOKING_MESSAGE_BY_SITE = {
  GIT: [
    'La reserva fue generada, pero el proveedor informó un cambio o ',
    'inconsistencia que requiere validación.\n',
    'Por favor, comunicate con tu vendedor de GIT para revisar el estado ',
    'de la reserva y definir los pasos a seguir.',
  ],
  TDH: [
    'Estamos verificando algunos detalles de tu reserva, por favor ',
    'comunicate con tu asesor de viajes para conocer su estado.',
  ],
};

export const getReviewBookingMessage = ({ site }) =>
  REVIEW_BOOKING_MESSAGE_BY_SITE[site].join('');

const DENIED_BOOKING_MESSAGE_BY_SITE = {
  GIT: [
    'El proveedor no pudo confirmar la ',
    'disponibilidad del alojamiento y la reserva fue rechazada.\n',
    'Volvé a intentar o comunicate con tu vendedor de GIT.',
  ],
  TDH: [
    'No pudimos confirmar la disponibilidad del alojamiento, por favor ',
    'intentá nuevamente o contactá a tu asesor de viajes',
  ],
};

export const getDeniedBookingMessage = ({ site }) =>
  DENIED_BOOKING_MESSAGE_BY_SITE[site].join('');

const DENIED_PAYMENT_MESSAGE_BY_SITE = {
  GIT: [
    'El proveedor no pudo confirmar la ',
    'disponibilidad del alojamiento y la reserva fue rechazada.\n',
    'Si el pago fue procesado, no te preocupes: nuestro equipo ',
    'revisará la operación y te dará la mejor alternativa disponible.\n',
    'Ante cualquier consulta, comunicate con tu vendedor de GIT.',
  ],
  TDH: [
    'El proveedor no pudo confirmar la ',
    'disponibilidad del alojamiento y la reserva fue rechazada.\n',
    'Si el pago fue procesado, no te preocupes: nuestro equipo ',
    'revisará la operación y te dará la mejor alternativa disponible.\n',
    'Ante cualquier consulta, comunicate con tu asesor de Viajes TDH.',
  ],
};

export const getDeniedPaymentMessage = ({ site }) =>
  DENIED_PAYMENT_MESSAGE_BY_SITE[site].join('');

const REVIEW_PAYMENT_MESSAGE_BY_SITE = {
  GIT: [
    'No fue posible confirmar tu reserva.',
    'Te pedimos que te comuniques con tu vendedor de GIT',
    '. Ellos podrán verificar el estado de la operación y ayudarte a ',
    'encontrar la mejor solución.',
  ],
  TDH: [
    'No fue posible confirmar tu reserva.',
    'Te pedimos que te comuniques con la agencia donde realizaste la compra',
    '. Ellos podrán verificar el estado de la operación y ayudarte a ',
    'encontrar la mejor solución.',
  ],
};

export const getReviewPaymentMessage = ({ site }) =>
  REVIEW_PAYMENT_MESSAGE_BY_SITE[site].join('');
